<div class="tw-flex tw-items-center tw-justify-between" id="page-title">
  <div class="tw-flex tw-items-baseline tw-max-w-[calc(100%_-_500px)]">
    <button (click)="back()" mat-icon-button id="back-btn">
      <mat-icon class="">west</mat-icon>
    </button>
    <h1 class="matp-page-title tw-mr-auto tw-truncate">{{ deviceName }}</h1>
  </div>

  <div class="tw-flex tw-justify-end tw-items-center">
    <div class="tw-mr-4 tw-text-gray-500">
      @if (lastCommunicationAt !== "") {
        <span>最終更新日時：</span>
        <span>{{ lastCommunicationAt | date: " yyyy/MM/dd HH:mm" }}</span>
      }
    </div>
    <div class="tw-mr-4">
      @if (fmdEnabled === true && fmdOn) {
        <mat-icon>airplanemode_active</mat-icon>
      } @else if (fmdEnabled === true && fmdOn !== true) {
        <mat-icon>airplanemode_inactive</mat-icon>
      }
    </div>
    @if (batteryPercentage !== null && batteryPercentage !== undefined) {
      <div class="!tw-w-10 !tw-h-10">
        <app-battery-icon
          [batteryPercentage]="batteryPercentage"
          [customClass]="'tw-text-4xl'"
        ></app-battery-icon>
      </div>
    }
    <div class="tw-text-gray-500 tw-text-xl">
      <span>{{ getBatteryValue("%", batteryPercentage) }}</span>
    </div>
    <a id="csv-download" style="display: none"></a>
  </div>
</div>

<div id="device-detail-summary tw-items-baseline">
  <div class="tw-flex tw-items-center tw-justify-between">
    @if (historyFormGroup) {
      <div class="tw-flex tw-items-center">
        <div>
          <app-datetime-range-picker
            [formGroup]="historyFormGroup"
            startFormControlName="historyFrom"
            endFormControlName="historyTo"
          ></app-datetime-range-picker>
          @if (
            historyFormGroup.controls["historyFrom"].errors?.["dateTooEarly"]
          ) {
            <mat-error class="tw-text-xs">
              期間は直近２か月以内で指定してください。
            </mat-error>
          }
          @if (
            historyFormGroup.controls["historyFrom"].errors?.[
              "dateBeforeCreation"
            ]
          ) {
            <mat-error class="tw-text-xs">
              期間はテナント作成日時
              {{ tenantCreatedAt | date: "yyyy/MM/dd HH:mm" }}
              より後の日時を指定してください。
            </mat-error>
          }
        </div>

        <div class="tw-ml-4">
          <button
            mat-raised-button
            id="search-btn"
            class="tw-text-lg tw-mx-2"
            color="primary"
            [disabled]="historyFormGroup.invalid"
            (click)="historyFiltered.emit()"
          >
            <mat-icon>search</mat-icon>
            <span>検索</span>
          </button>
        </div>
      </div>
    }

    <div class="tw-flex tw-justify-end">
      <button
        mat-raised-button
        id="export-btn"
        color="primary"
        (click)="exportButtonClicked.emit()"
      >
        <mat-icon>Download</mat-icon>
        CSVエクスポート（BOM付）
      </button>
    </div>
  </div>

  <div class="tw-my-4">
    <mat-button-toggle-group
      name="toggle"
      class="matp-button-toggle-group !tw-flex tw-gap-x-2 tw-items-stretch !tw-overflow-x-auto !tw-border-0"
      [hideSingleSelectionIndicator]="'true'"
      [(ngModel)]="selectedBtn"
      (change)="onSensingBtnChanged($event)"
    >
      @for (option of summaryBtnOptions; track option.key) {
        @if (isAvailability(option.key)) {
          <mat-button-toggle
            [value]="option.key"
            class="matp-button-toggle tw-flex-1 tw-flex tw-items-center !tw-border !tw-border-solid !matp-border-default tw-py-[0.6rem]"
            [class.matp-button-toggle--off]="isSensorOff(option.key)"
            [disabled]="!hasSensingData(option.key)"
          >
            <div class="tw-flex tw-leading-normal">
              <div class="tw-flex tw-flex-col tw-relative tw-justify-center">
                <!-- アイコン -->
                <div class="tw-flex">
                  <mat-icon class="tw-text-4xl !tw-h-9 !tw-w-9 tw-leading-9">
                    {{ option.iconName }}
                  </mat-icon>
                </div>

                <!-- アラート表示 -->
                <div class="tw-absolute tw-top-4 tw-left-5">
                  @if (getSensingStatus(option.key, option.type) === "Alert") {
                    <mat-icon class="tw-text-red-500">
                      {{ option.type === "battery" ? "info" : "error" }}
                    </mat-icon>
                  } @else if (
                    getSensingStatus(option.key, option.type) === "PreAlert"
                  ) {
                    <mat-icon class="tw-text-yellow-500">warning</mat-icon>
                  }
                </div>

                <!-- ラベル -->
                <div>{{ option.label }}</div>
              </div>

              <div class="tw-flex tw-flex-col tw-ml-3 tw-grow tw-min-w-20">
                <div class="tw-text-xl tw-text-center tw-truncate tw-h-8">
                  @if (option.type === "sensor" || option.type === "battery") {
                    {{ getSensingValue(option.key, option.unit) }}
                  }
                </div>
                <div class="tw-text-xs">
                  {{ getSensingDateTime(option.key) | date: "yyyy/MM/dd"
                  }}<br />
                  {{ getSensingDateTime(option.key) | date: "HH:mm" }}
                </div>
              </div>
            </div>
          </mat-button-toggle>
        }
      }
    </mat-button-toggle-group>
  </div>
</div>
